import { JobSearchCriteria } from '@/lib/jobMatching';

// A candidate's saved job-board search ("Bevakning"). When a new posting matches
// the saved free-text query AND structured criteria (#39 Phase 2), the candidate
// gets an in-app notification. `criteria` is absent for legacy free-text-only
// watches.
export interface NeedSubscription {
    id: string;
    // The candidate's own name for the saved search ("Heltid, Socionom i Göteborg").
    // Empty for legacy watches — fall back to `label` (the derived summary).
    name: string;
    query: string;
    criteria?: JobSearchCriteria;
    label: string;
    created_at: string;
}

// The name to display for a bevakning: the candidate's own name, or the derived
// summary label when they never named it.
export function subscriptionDisplayName(s: NeedSubscription): string {
    return s.name?.trim() ? s.name.trim() : s.label;
}

export interface NeedSubscriptionListResponse {
    subscriptions: NeedSubscription[];
}
